import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/agent`;

export const fetchAllUserAgents = async () => {
  const res = await axiosInstance.get(`${BASE_URL}`, getAuthHeaders());
  return res.data;
};

export const deleteAgent = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const upsertAgent = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/upsert`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchAgent = async (uuid) => {
  const res = await axiosInstance.get(`${BASE_URL}/${uuid}`, getAuthHeaders());
  return res.data;
};